<template>
  <div class="text-ontick-carbon-900 px-6 py-12 dark:text-gray-300">
    <div class="absolute inset-0" v-if="loading">
      <div class="flex h-full w-full items-center justify-center">
        <i v-html="$icons.spinner_lg" class="animate-spin"></i>
      </div>
    </div>
    <template v-else>
      <success-component
        v-if="success"
        :data="successData"
        @changeAccount="changeAccount(successData)"
        @getConfig="getConfig"
      />
      <error-component v-else :data="errorData" @changeAccount="changeAccount(errorData)" @getConfig="getConfig" />
    </template>
  </div>
</template>

<script>
import successComponent from "../components/success.component.vue";
import errorComponent from "../components/error.component.vue";
import { mapActions, mapGetters } from "vuex";
import EventBus from "../../../shared/utils/event_bus";
export default {
  components: {
    successComponent,
    errorComponent,
  },

  data() {
    return {
      loading: true,
      success: null,
      successData: {},
      errorData: {},
    };
  },

  computed: {
    ...mapGetters({ getAccounts: "accountTypes/getAccounts" }),
  },

  methods: {
    ...mapActions({
      setUserConfig: "config/setUserConfig",
      fetchAccounts: "accountTypes/fetchAccounts",
      updateAccount: "accountTypes/updateAccount",
    }),
    createAccount() {
      this.loading = true;
      this.$api
        .get(this.$endpoint.CREATE_CHAMPIONSHIP_ACCOUNT, {
          params: { tournament_id: this.$route.params.contest_code },
        })
        .then(({ data }) => {
          // console.log(data);
          this.successData = data;
          this.success = true;
        })
        .catch(({ data }) => {
          console.error(data);
          this.errorData = data;
          this.success = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeAccount(data) {
      // console.log(data);
      this.updateAccount({
        account: this.getAccounts.find((item) => item.account_id === data.account_id),
      });
      EventBus.$emit("CHANGE_ACCOUNT");
      this.$router.push({ name: "Dashboard" });
    },
    getConfig() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.USER_CONFIGS)
          .then((response) => {
            this.setUserConfig(response.data);
            this.fetchAccounts(response.data.accounts);
            resolve();
          })
          .catch((error) => {
            if (error.data.status == "error") {
              this.setUserConfig(error.data);
            }
            reject();
          });
      });
    },
  },

  created() {
    this.createAccount();
  },
};
</script>

<style></style>
